import React from 'react'

const ListItems = (props) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  )
}

export default ListItems